import { useState, useEffect } from "react";
import { Flex, View } from "@adobe/react-spectrum";
import { useSelector } from "react-redux";
import ChatList from "../../ChatPage/ChatList/ChatList";
import ChatHeader from "../ChatHeader/ChatHeader";
import ChatDetails from "../ChatDetails/ChatDetails";
import ChatTranscript from "../ChatTranscript/ChatTranscript";
import { RootState } from "../../../store/storeConfig";
import { IndividualChat } from "../../../types/chat.type";
import ActiveCallContainer from "../../CallTab/CallDialer/ActiveCallContainer";
import ChannelHistoryFilter from "../../common/ChannelHistoryFilter/ChannelHistoryFilter";

const ChatHistory = () => {
  const history = useSelector((state: RootState) => state.history);

  const [chatDetail, setChatDetail] = useState<any>({});
  const [showChatDetail, setShowChatDetail] = useState<boolean>(true);
  const [uplodingFiles, setUploadingFiles] = useState({});
  const [filterAction, setFilterAction] = useState<"all" | "missed">("all");
  const [chatList, setChatList] = useState<IndividualChat[]>(
    history.chat || []
  );

  useEffect(() => {
    if (history.chat?.length > 0) {
      setChatDetail(history.chat[0]);
      setChatList(history.chat);
    }
  }, [history.chat]);

  const handleAll = () => {
    setFilterAction("all");
    setChatList(history.chat);
  };

  const handleMissed = () => {
    setFilterAction("missed");
    const missedChats = history.chat.filter(
      (chatItem: IndividualChat) => chatItem?.self?.missed
    );
    setChatList(missedChats);
  };

  const handleActiveChatId = (id: string) => {
    const activeChat = history.chat.find(
      (chatItem: IndividualChat) => chatItem.id === id
    );
    setChatDetail(activeChat);
  };

  const handleShowChatDetail = () => {
    setShowChatDetail(!showChatDetail);
  };

  return (
    <>
      {history?.chat?.length > 0 && (
        <>
          <ChannelHistoryFilter
            activeFilter={filterAction}
            onAll={handleAll}
            onMissed={handleMissed}
          />
          {chatList.length > 0 ? (
            <Flex direction={"row"} height="90.5%" width={"100%"}>
              <View
                backgroundColor="static-white"
                width={"23%"}
                borderEndWidth={"thick"}
                borderEndColor={"gray-200"}
              >
                <ChatList
                  chat={chatList}
                  activeChatId={chatDetail?.id}
                  handleActiveChatId={handleActiveChatId}
                />
              </View>

              <Flex direction={"column"} width={"76.5%"}>
                <View backgroundColor="static-white">
                  <ChatHeader
                    chatDetail={chatDetail}
                    showChatDetail={showChatDetail}
                    handleShowChatDetail={handleShowChatDetail}
                  />
                </View>
                {showChatDetail && (
                  <View backgroundColor="static-white">
                    <ChatDetails chatDetail={chatDetail} />
                  </View>
                )}
                <View
                  backgroundColor="static-white"
                  UNSAFE_className="chat-transcript-container"
                  height={"80%"}
                >
                  <ChatTranscript
                    chatType={"chatHistory"}
                    typingStatus={false}
                    activeChatId={chatDetail?.id}
                    uplodingFiles={uplodingFiles}
                    setUploadingFiles={setUploadingFiles}
                  />
                </View>
              </Flex>
            </Flex>
          ) : (
            !chatList.length && (
              <Flex
                alignItems="center"
                justifyContent="center"
                width="90%"
                height="90%"
              >
                <ActiveCallContainer
                  type="chat"
                  title={"No Missed Chat history"}
                  description={"Start a new chat or wait for the chat"}
                />
              </Flex>
            )
          )}
        </>
      )}

      {!history?.chat?.length && (
        <Flex
          alignItems={"center"}
          justifyContent={"center"}
          height={"100%"}
          width={"100%"}
        >
          <ActiveCallContainer
            type="chat"
            title="No chat in history"
            description="There is no chat history at this time"
          />
        </Flex>
      )}
    </>
  );
};

export default ChatHistory;
